import Button from "components/ui/button"
import Picture from "components/ui/picture"
import { jewlr_t } from "helpers/application"
import { getImgSrcSet } from "helpers/image"

const LuxuryCollection = () => {
  return (
    <div className="bg-black-print" id="luxury-bridal-collection">
      <div className="tablet:items-start contained-wide tablet:gap-40 tablet:grid-cols-2 desktop:py-60 widescreen:px-60 grid grid-cols-1 items-center gap-20 p-16">
        <Picture
          alt="2 ct. (8mm) Moissanite Engagement Ring with Hidden Halo"
          fallback="https://cms.jewlr.com/luxury_bridal_collection_2x_3ebaef53bf/luxury_bridal_collection_2x_3ebaef53bf.jpg"
          srcSet={[
            {
              height: 600,
              media: "(max-width: 1023px)",
              sizes: "(max-width: 767px) calc(100vw - 32px), 50vw",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/m_luxury_bridal_collection_2x_afb543ac9e/m_luxury_bridal_collection_2x_afb543ac9e.jpg`,
                686
              ),
              width: 686,
            },
            {
              height: 1684,
              media: "(min-width: 1024px)",
              sizes: "(max-width: 1920px) 50vw, 880px",
              srcSet: getImgSrcSet(
                `${sl.config.jewlr_imgsmbly_url}cms/luxury_bridal_collection_2x_3ebaef53bf/luxury_bridal_collection_2x_3ebaef53bf.jpg`,
                1760
              ),
              width: 1760,
            },
          ]}
        />
        <div className="text-white">
          <h2 className="h2 mb-20">
            LUXURY BRIDAL COLLECTION
            <br />
            LIFETIME WARRANTY
          </h2>
          <h3 className="h3 mb-10">What&apos;s Covered</h3>
          <p className="body mb-20">
            Our Luxury Bridal Collection diamond engagement rings come with a
            limited <b>lifetime warranty</b>, offering exceptional peace of mind
            for your most cherished purchase. This warranty covers:
          </p>
          <ul className="body mb-40 pl-20">
            <li>
              <b>Manufacturing defects</b> such as metal (cracks or breaks) or
              setting issues (damaged prongs)
            </li>
            <li>
              <b>Craftsmanship problems</b> affecting durability or
              functionality
            </li>
          </ul>

          <h3 className="h3 mb-10">What&apos;s Not Covered</h3>
          <p className="body mb-20">
            While our warranty provides extensive coverage, some exclusions
            apply:
          </p>
          <ul className="body mb-40 pl-20">
            <li>Loss of the stone or the entire ring</li>
            <li>Damage from third-party resizing or repairs</li>
          </ul>
          <h3 className="h3 mb-10">Important Notes</h3>
          <ul className="body mb-40 pl-20">
            <li>
              <b>Exclusive Maintenance:</b> Jewlr must complete all repairs and
              resizing to maintain your lifetime warranty
            </li>
            <li>
              <b>Non-Covered Repairs:</b> Repairs or adjustments made by another{" "}
              {jewlr_t("terms.jeweler")} will void your warranty
            </li>
          </ul>
          <p className="body mb-40">
            The Luxury Bridal Collection lifetime warranty reflects our
            commitment to quality and ensures your engagement ring remains as
            stunning as the day you received it. For assistance with your
            warranty, contact us at{" "}
            <Button asChild underline>
              <a
                href={`mailto:${sl.config.customer_service_email}`}
                rel="nofollow"
              >
                {sl.config.customer_service_email}
              </a>
            </Button>
          </p>
        </div>
      </div>
    </div>
  )
}

export default LuxuryCollection
